import { facilityStayAction } from '../../actions/constant';

const {
  GET_PATIENTS_REQUEST,
  GET_PATIENTS_SUCCESS,
  GET_PATIENTS_FAILURE,
  GET_PATIENTS_LOADER,
  GET_PATIENTS_RESET,
} = facilityStayAction;

const initialState: any = {
  getAllPatients: false,
  response: null,
  loading: false,
  totalPatients: [],
  currentPage: -1,
  pageNumber: 0,
};

export const getAllPatientsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_PATIENTS_SUCCESS: {
      const newPageNumber = action.payload?.data?.number;
      if (state.currentPage + 1 === newPageNumber) {
        return {
          ...state,
          getAllPatients: true,
          response: action.payload,
          loading: false,
          currentPage: newPageNumber,
          totalPatients: [...state.totalPatients, ...action.payload?.data?.content],
          pageNumber: state.pageNumber + 1,
        };
      } else {
        return {
          ...state,
          getAllPatients: true,
          response: action.payload,
          loading: false,
          currentPage: newPageNumber,
          totalPatients: action.payload?.data?.content || [],
        };
      }
    }

    case GET_PATIENTS_FAILURE:
      return {
        ...state,
        getAllPatients: false,
        response: action.payload,
        loading: false,
      };

    case GET_PATIENTS_LOADER:
      return {
        ...state,
        loading: true,
      };

    case GET_PATIENTS_RESET:
      return initialState;

    default:
      return state;
  }
};
